import { CrmPageNotificationsProvider } from '../contexts/CrmPageNotificationsContext';
import { PortalProvider } from '../contexts/PortalContext';
import type { PortalKind } from '../lib/portal';
import { RequireAuth } from './RequireAuth';
import { RequirePortalChoice } from './RequirePortalChoice';
import { PurchasingAppShell } from './layout/PurchasingAppShell';

export function PurchasingPortalApp({ kind }: { kind: PortalKind }) {
  return (
    <PortalProvider kind={kind}>
      <RequireAuth>
        <RequirePortalChoice>
          <CrmPageNotificationsProvider>
            <PurchasingAppShell />
          </CrmPageNotificationsProvider>
        </RequirePortalChoice>
      </RequireAuth>
    </PortalProvider>
  );
}
